import { defineStore } from 'pinia';
import state from './state.js';

export const useFlowStore = defineStore({
    id: 'flow',
    state() {
        return state;
    },
});
